import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { SITE_SPECIFIC_TRAINING_PDF_REPORT_BASE } from '../training-pdf-report-base.token';
import { API_BASE } from '../api-base.token';
import { SiteSpecificTrainingPdfRequest } from './site-specific-training-pdf-request';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class SiteSpecificTrainingPdfHttpService {
  constructor(
    @Inject(SITE_SPECIFIC_TRAINING_PDF_REPORT_BASE)
    private readonly siteSpecificTrainingPdfReportBase: string,
    @Inject(API_BASE)
    private readonly apiBase: string,
    private readonly httpClient: HttpClient
  ) {}

  generateSiteSpecificTrainingPdf(training: SiteSpecificTrainingPdfRequest) {
    return this.httpClient.post(
      this.siteSpecificTrainingPdfReportBase,
      training,
      {
        responseType: 'blob', // Specify that we expect a binary response (PDF)
      }
    );
  }

  generateSiteSpecificTrainingPdfV2(training: SiteSpecificTrainingPdfRequest) {
    const url = Location.joinWithSlash(this.apiBase, 'pdfengine/training');
    return this.httpClient.post(url, training, {
      responseType: 'blob', // Specify that we expect a binary response (PDF)
    });
  }
}
